import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirect } from "@/lib/legacy-redirect";

export const Route = createFileRoute("/energy-audit")({
  beforeLoad: () => legacyRedirect("/energy-management/energy-audits"),
});
